var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconConfused(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 60,
    viewBox: "0 0 59 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.6978 52.8569C42.0278 52.8569 52.0233 42.6234 52.0233 29.9997C52.0233 17.3761 42.0278 7.14258 29.6978 7.14258C17.3677 7.14258 7.37219 17.3761 7.37219 29.9997C7.37219 42.6234 17.3677 52.8569 29.6978 52.8569Z",
    fill: "url(#paint0_radial_4760_27460)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M29.6978 52.8569C42.0278 52.8569 52.0233 42.6234 52.0233 29.9997C52.0233 17.3761 42.0278 7.14258 29.6978 7.14258C17.3677 7.14258 7.37219 17.3761 7.37219 29.9997C7.37219 42.6234 17.3677 52.8569 29.6978 52.8569Z",
    fill: "url(#paint1_radial_4760_27460)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4138 30.9716C23.6005 30.9716 24.5626 29.4814 24.5626 27.643C24.5626 25.8047 23.6005 24.3145 22.4138 24.3145C21.227 24.3145 20.2649 25.8047 20.2649 27.643C20.2649 29.4814 21.227 30.9716 22.4138 30.9716Z",
    fill: "url(#paint2_radial_4760_27460)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4138 25.4432C23.3347 25.4432 24.144 26.2718 24.5626 27.486C24.5347 25.686 23.5859 24.2432 22.4138 24.2432C21.2417 24.2432 20.2928 25.686 20.2649 27.486C20.6835 26.2718 21.4789 25.4432 22.4138 25.4432Z",
    fill: "url(#paint3_linear_4760_27460)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M36.9816 30.9716C38.1683 30.9716 39.1304 29.4814 39.1304 27.643C39.1304 25.8047 38.1683 24.3145 36.9816 24.3145C35.7948 24.3145 34.8328 25.8047 34.8328 27.643C34.8328 29.4814 35.7948 30.9716 36.9816 30.9716Z",
    fill: "url(#paint4_radial_4760_27460)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M36.9816 25.5291C36.0607 25.5291 35.2513 26.3577 34.8328 27.572C34.8607 25.772 35.8095 24.3291 36.9816 24.3291C38.1537 24.3291 39.1026 25.772 39.1304 27.572C38.7118 26.3577 37.9165 25.5291 36.9816 25.5291Z",
    fill: "url(#paint5_linear_4760_27460)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M39.1027 39.972H20.2935C19.7214 39.972 19.2469 39.4863 19.2469 38.9005C19.2469 38.3149 19.7214 37.8291 20.2935 37.8291H39.1027C39.6748 37.8291 40.1493 38.3149 40.1493 38.9005C40.1493 39.4863 39.6748 39.972 39.1027 39.972Z",
    fill: "url(#paint6_radial_4760_27460)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1958 38.4005H39.2144C39.619 38.4005 39.9818 38.6435 40.1493 38.9863C40.1493 38.9577 40.1493 38.9292 40.1493 38.9006C40.1493 38.3149 39.6748 37.8291 39.1027 37.8291H20.2935C19.7214 37.8291 19.2469 38.3149 19.2469 38.9006C19.2469 38.9292 19.2469 38.9577 19.2469 38.9863C19.4283 38.6292 19.7772 38.4005 20.1958 38.4005Z",
    fill: "url(#paint7_linear_4760_27460)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7487 20.414C24.9394 20.4569 24.1999 20.4426 22.4138 19.8997C19.7766 19.114 19.1348 19.714 17.4045 21.3283C17.279 21.4426 17.1394 21.5712 16.9999 21.6997C16.7208 21.9569 16.6789 22.4283 16.9301 22.7998C17.0836 23.0283 17.6976 23.3998 18.2418 22.9283C19.9301 21.4855 21.172 21.6426 22.665 22.0141C23.8511 22.2997 25.079 22.6141 26.3906 21.9569C26.9208 21.6997 27.0604 21.314 26.9348 20.8997C26.7813 20.3854 26.3208 20.3712 25.7487 20.414Z",
    fill: "url(#paint8_linear_4760_27460)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7443 18.2714C34.5535 18.2 35.2373 17.9857 36.9814 17.2571C39.1442 16.3571 40.6233 16.8143 42.1303 17.9143C42.2698 18.0143 42.4233 18.1143 42.5908 18.2285C42.9117 18.4429 43.0094 18.9143 42.814 19.3C42.7023 19.5428 42.1303 20 41.5302 19.6286C39.6465 18.4571 38.4465 18.8 37.0233 19.3857C35.8931 19.8572 34.721 20.3429 33.3256 19.8857C32.7675 19.7 32.5722 19.3571 32.6279 18.9286C32.7116 18.4143 33.1721 18.3286 33.7443 18.2714Z",
    fill: "url(#paint9_linear_4760_27460)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_4760_27460",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(25.3052 20.7365) scale(26.9329 27.5742)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE030"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB92E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_4760_27460",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(25.3052 20.7365) scale(21.1893 21.6938)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEA5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBC47",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_4760_27460",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(21.7563 27.7308) rotate(74.2106) scale(3.22382 2.04452)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#7A4400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#643800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4760_27460",
    x1: 22.4085,
    y1: 24.3017,
    x2: 22.4085,
    y2: 27.4038,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#3C2200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#512D00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_4760_27460",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(36.3354 27.7313) rotate(74.2105) scale(3.22383 2.04452)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#7A4400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#643800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_4760_27460",
    x1: 36.9869,
    y1: 24.3836,
    x2: 36.9869,
    y2: 27.4856,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#3C2200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#512D00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_4760_27460",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(29.6981 38.8946) scale(7.42704 1.36794)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#7A4400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#643800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_4760_27460",
    x1: 19.2469,
    y1: 38.3999,
    x2: 40.1493,
    y2: 38.3999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#3C2200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#512D00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_4760_27460",
    x1: 21.9223,
    y1: 24.0273,
    x2: 21.8248,
    y2: 19.8369,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#3C2200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7A4400"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_4760_27460",
    x1: 37.7629,
    y1: 21.2263,
    x2: 37.7629,
    y2: 17.2217,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#3C2200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7A4400"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconConfused);
export default __webpack_public_path__ + "static/media/icon_confused.232cd6d4565a81dbd075cc7b54a9117a.svg";
export { ForwardRef as ReactComponent };